import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=da60fbd4&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/contract_form/personal_info.css?vue&type=style&index=0&id=da60fbd4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da60fbd4",
  null
  
)

export default component.exports